import { useEffect, useState } from "react";
import { OtpPropsType } from "./index";
import { toast } from "react-toastify";
import { getNotifyConfig } from "@utils/helpers";
import { useUI } from "@context/ui-managed-context";
import { userApi } from "gate";
import { useAppContext } from "@context/app";
import useEvents from "@hooks/useEvents";

export const UseOtp = (props: OtpPropsType) => {
  const [otp, setOtp] = useState("");
  const { setModalView, openModal, modalView } = useUI();
  const [loading, setLoading] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [initialSeconds, setInitialSeconds] = useState<number>(props.timer);
  const [seconds, setSeconds] = useState<number>(initialSeconds);
  const [timerFinished, setTimerFinished] = useState<boolean>(props.timer === 0 ? true : false);
  const { setSyncData, syncData, country } = useAppContext();
  const { OTPFormOpened, OTPFormFailed, OTPFormSubmitted, phoneVerified } = useEvents();
  const defaultStep: "OTP" | "PHONE_NUMBER" | undefined = modalView.args[1];
  const onComplete: undefined | ((finishedAndVerified: boolean) => void) = modalView.args[3]
  useEffect(() => {
    OTPFormOpened();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!timerFinished) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds === 0) {
            clearInterval(timer);
            setTimerFinished(true);
            return 0;
          }
          return prevSeconds - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [initialSeconds, timerFinished]);

  const formatTime = (time: number): string => {
    return time < 10 ? `0${time}` : time.toString();
  };

  const minutes: string = formatTime(Math.floor(seconds / 60));
  const remainingSeconds: string = formatTime(seconds % 60);

  const handleVerify = () => {
    if (loading) return;
    setLoading(true);

    userApi
      .verifyCode({ phone: `${props.countryCode}${props.phoneNumber}`, code: otp })
      .fetch()
      .then((res) => {
        if (syncData && res.data) {
          setSyncData({ ...syncData, user: res.data });
        }
        OTPFormSubmitted();
        phoneVerified(`${props.countryCode}${props.phoneNumber}`);
        setModalView("VERIFY_PHONE_NUMBER_SUCCESS", false, defaultStep ? true : false, onComplete);
        openModal();
      })
      .catch((err) => {
        OTPFormFailed(`${props.countryCode}${props.phoneNumber}`, err?.meta?.msg ?? "");
        console.log(err);
        setOtp("");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formatPhoneNumber = (phoneNumber: string): string => {
    const cleaned: string = phoneNumber.replace(/\D/g, "");
    if (cleaned === "" || isNaN(parseInt(cleaned))) {
      return "";
    }
    const countryCode: string = cleaned.slice(0, 3);
    const firstPart: string = cleaned.slice(3, 7);
    const secondPart: string = cleaned.slice(7, 11);

    return `+${countryCode} ${firstPart} ${secondPart}`;
  };

  const handleResend = async (method?: "whatsapp" | "sms") => {
    if (isProcessing) return;
    setIsProcessing(true);
    userApi
      .sendCode({ phone: `${props.countryCode}${props.phoneNumber}`, type: method || "sms" })
      .fetch()
      .then((res) => {
        setInitialSeconds(res.data.wait || 60);
        setSeconds(res.data.wait || 60);
        setTimerFinished(false);
        toast.success("Your code was sent successfully", getNotifyConfig());
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsProcessing(false);
      });
  };

  const handleEdit = () => {
    props.onChangeStep("PHONE_NUMBER");
  };

  return {
    handleVerify,
    loading,
    formatPhoneNumber,
    handleEdit,
    handleResend,
    minutes,
    remainingSeconds,
    timerFinished,
    otp,
    setOtp,
    seconds,
    formatTime,
    isProcessing,
    contact: country?.contact,
  };
};